import { createContext } from "react";
import { OrgApp } from "../types/models/OrgApp";
import { useLocalStorage } from "usehooks-ts";
import { areDefined } from "../utils/validation";

interface OrgAppContextProps {
    orgApp: OrgApp,
    setOrgApp: (value: React.SetStateAction<OrgApp>) => void,
    isSelectedOrg: (org?: OrgApp) => boolean,
}

export const OrgAppContext = createContext<OrgAppContextProps | undefined>(undefined);

export const OrgAppProvider = (props: { children: React.ReactNode }) => {
    const [orgApp, setOrgApp] = useLocalStorage<OrgApp>('OrgApp', {});

    // Overloaded function to check selected org domain state
    const isSelectedOrg = (org?: OrgApp): boolean => {
        if (areDefined(org?.domainId, org?.organisationId)) {
            return orgApp.domainId === org?.domainId &&
                orgApp.organisationId === org?.organisationId;
        }
        return areDefined(orgApp.domainId, orgApp.organisationId);
    }
    
    return (
        <OrgAppContext.Provider value={{ orgApp, setOrgApp, isSelectedOrg }}>
            {props.children}
        </OrgAppContext.Provider>
    );
}